<template>
	
	<div class="c-table__filter">
		<c-select-search
			:placeholder="placeholder"
			:options="options"
			:searchable="true"
			@search="$emit('search', $event)"
			v-model="filterValue"
			:name="placeholder"
			:ValueName="'id'"
			:DisplayName="'name'"
		/>
	</div>

</template>

<script>
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	data() {
		return {
			filterValue: ''
		}
	},
	props: {
		placeholder: {
			type: String,
			default: 'Filter op ...'
		},
		options: {
			type: Array,
			default: () => []
		},
		name: {
			type: String,
			default: 'filter'
		},
	},
	watch: {
		filterValue: {
			handler(newValue) {
				this.$emit('update:filterValues', newValue, this.name);
			},
			deep: true
		}
	},
}
</script>